<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/system-setup/vessels"></back-button>
          Update Vessel
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">System Setup</li>
          <li class="breadcrumb-item">
            <router-link :to="`/system-setup/vessels`">Vessels</router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="vessel-tab"
                  data-bs-toggle="tab"
                  href="#vessel"
                  role="tab"
                  aria-controls="vessel"
                  aria-selected="true"
                  >Vessel info</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="signing-status-tab"
                  data-bs-toggle="tab"
                  href="#signing-status"
                  role="tab"
                  aria-controls="signing-status"
                  aria-selected="false"
                  >Tab 4</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="vesselSpeed-tab"
                  data-bs-toggle="tab"
                  href="#vesselSpeed"
                  role="tab"
                  aria-controls="vesselSpeed"
                  aria-selected="false"
                  >Vessel Speed</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="vesselConsumption-tab"
                  data-bs-toggle="tab"
                  href="#vesselConsumption"
                  role="tab"
                  aria-controls="vesselConsumption"
                  aria-selected="false"
                  >Vessel Consumption</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For General Sectiion -->
              <div
                class="tab-pane fade show active"
                id="vessel"
                role="tabpanel"
                aria-labelledby="vessel-tab"
              >
                <h4>
                  <i class="link-arrow" data-feather="edit"></i> Vessel info
                </h4>
                <hr />
                <vessel-form :form="form"></vessel-form>
              </div>
              <!-- For Tap 4 -->
              <div
                class="tab-pane fade"
                id="signing-status"
                role="tabpanel"
                aria-labelledby="signing-status-tab"
              >
                <vessel-2-form :form="form"></vessel-2-form>
              </div>
              <div
                class="tab-pane fade"
                id="vesselSpeed"
                role="tabpanel"
                aria-labelledby="vesselSpeed-tab"
              >
                <h4>Vessel Speed</h4>
                <hr />
                <vessel-speed :form="form"></vessel-speed>
              </div>
              <div
                class="tab-pane fade"
                id="vesselConsumption"
                role="tabpanel"
                aria-labelledby="vesselConsumption-tab"
              >
                <h4>Vessel Consumption</h4>
                <hr />
                <vessel-consumption :form="form"></vessel-consumption>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import vesselForm from "./vessel-form.vue";
import Vessel2Form from "./vessel-2-form.vue";
import VesselSpeed from "./vessel-speed.vue";
import VesselConsumption from "./vessel-consumption.vue";

export default {
  components: { vesselForm, Vessel2Form, VesselSpeed, VesselConsumption },
  name: "VesselUpdate",
  data() {
    return {
      form: {
        vessel_type: "",
        owner_id: "",
        engine_type: "",
        sub_organzation_id: "",
        vessel_speeds: [],
        vessel_consumptions: [],
      },
      vessel_types: [],
      owners: [],
      engneTypes: [],
      organzations: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/vessels/${this.$route.params.vesselId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.isLoading = true;
        await axios.post(`/vessels`, this.form);
        this.isLoading = false;
        this.$router.push("/system-setup/vessels");
      } catch (e) {
        this.isLoading = false;
      }
    },
    async handleFileUpload() {
      this.imagepath = this.$refs.imagepath
        ? this.$refs.imagepath.files[0]
        : "";
      this.attachment = this.$refs.attachment
        ? this.$refs.attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("imagepath", this.imagepath);
      formData.append("attachment", this.attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
    async handleDocumentUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
